import { ServerConfig } from "@/config/config";
import { Axios } from "@/services/auth-service";
import { IPaginationData, paginationToQuery } from "@/utils/browse/pagination-data";
import { IPaginatedResponse } from "@/utils/browse/pagination-response";

export type ReferralRewardedFilter = "all" | "rewarded" | "unrewarded";
export type InviteStatusFilter = "all" | "sent" | "registered";

export interface IReferral {
	id:number;
	referrerCompanyId:number;
	referredCompanyId:number;
	referrerCompanyName:string;
	referredCompanyName:string;
	code:string;
	dateCreated:string;
	rewarded:boolean;
	rewardedAt:string|null;
	rewardNote:string;
}

export interface IReferralInvite {
	id:number;
	referrerCompanyId:number;
	referrerCompanyName?:string;
	email:string;
	code:string;
	status:"sent"|"registered";
	dateSent:string;
}

export interface ICompanyReferrals {
	broughtIn:IReferral[];
	referredBy:IReferral|null;
	invites:IReferralInvite[];
}

export class ReferralServiceClass{
	readonly url = ServerConfig.host + "/admin/referrals";

	async getAllReferrals(paginationData:IPaginationData, rewardedFilter:ReferralRewardedFilter = "all"):Promise<IPaginatedResponse<IReferral>>{
		let params = paginationToQuery(paginationData) as any;
		if (rewardedFilter == "rewarded"){
			params.rewarded = "true";
		}else if (rewardedFilter == "unrewarded"){
			params.rewarded = "false";
		}
		let res = await Axios.get(`${this.url}`, {params});
		return {
			data: res.data.data || [],
			records: res.data.records || 0
		};
	}

	async getAllInvites(paginationData:IPaginationData, statusFilter:InviteStatusFilter = "all"):Promise<IPaginatedResponse<IReferralInvite>>{
		let params = paginationToQuery(paginationData) as any;
		if (statusFilter != "all"){
			params.status = statusFilter;
		}
		let res = await Axios.get(`${this.url}/invites`, {params});
		return {
			data: res.data.data || [],
			records: res.data.records || 0
		};
	}

	async getCompanyReferrals(companyId:number):Promise<ICompanyReferrals>{
		let res = await Axios.get(`${this.url}/company/${companyId}`);
		return {
			broughtIn: res.data.broughtIn || [],
			referredBy: res.data.referredBy || null,
			invites: res.data.invites || []
		};
	}

	async setRewarded(referralId:number, rewarded:boolean, note:string):Promise<IReferral>{
		let res = await Axios.post(`${this.url}/${referralId}/reward`, {rewarded, note});
		return res.data;
	}
}

export const ReferralService = new ReferralServiceClass();
